import React from "react";
import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";
import { useLanguage } from "../Context/LanguageContext";
import { FiGithub, FiLinkedin, FiTwitter, FiHeart } from "react-icons/fi";
import "./footer.css";

const Footer = () => {
  const { t } = useLanguage();
  const socials = [
    {
      href: "https://github.com/hebraheem",
      icon: <FiGithub size={18} />,
      label: "GitHub",
    },
    {
      href: "https://www.linkedin.com/in/ibrahim-adebiyi-b7b979166/",
      icon: <FiLinkedin size={18} />,
      label: "LinkedIn",
    },
    {
      href: "https://twitter.com/just_hebraheem",
      icon: <FiTwitter size={18} />,
      label: "Twitter",
    },
  ];

  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__brand mono">
          <NavLink to="/" className="footer__logo">
            <span style={{ color: "var(--accent-purple)" }}>ibrahim</span>
            <span style={{ color: "var(--accent-cyan)" }}>.</span>
            <span style={{ color: "var(--text-muted)" }}>dev</span>
          </NavLink>
        </div>

        <div className="footer__copy mono">
          <span style={{ color: "var(--text-muted)" }}>{`// ${t("MadeWith")} `}</span>
          <motion.span
            animate={{ scale: [1, 1.3, 1] }}
            transition={{
              duration: 1,
              repeat: Infinity,
              ease: "easeInOut",
            }}
            style={{
              display: "inline-block",
              color: "var(--accent-coral)",
            }}
          >
            <FiHeart size={13} />
          </motion.span>
          <span style={{ color: "var(--text-muted)" }}>
            {" "}
            {t("By")} @hebraheem · {new Date().getFullYear()}
          </span>
        </div>

        <div className="footer__socials">
          {socials.map(({ href, icon, label }) => (
            <motion.a
              key={label}
              href={href}
              target="_blank"
              rel="noreferrer"
              className="footer__social"
              aria-label={label}
              whileHover={{
                scale: 1.15,
                color: "var(--accent-cyan)",
              }}
              whileTap={{ scale: 0.9 }}
            >
              {icon}
            </motion.a>
          ))}
          <span className="footer__github-label mono">@hebraheem</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
